export default "__VITE_ASSET__Eh1B_qkm__"